// extracted by mini-css-extract-plugin
export default {"err_border":"appintake_err_border__glBEG"};